import { render, staticRenderFns } from "./NotFoundContent.vue?vue&type=template&id=0ddf9792&scoped=true"
import script from "./NotFoundContent.vue?vue&type=script&lang=ts"
export * from "./NotFoundContent.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundContent.vue?vue&type=style&index=0&id=0ddf9792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf9792",
  null
  
)

export default component.exports